import React from 'react';  
import { motion } from 'framer-motion';  
import { Twitter, Bell, Rocket } from 'lucide-react'; // Bell for Discord, Rocket for Telegram  

const Footer = () => {  
  return (  
    <motion.footer  
      initial={{ opacity: 0, y: 50 }}  
      animate={{ opacity: 1, y: 0 }}  
      transition={{ duration: 0.5, delay: 0.8 }}  
      className="bg-black border-t border-white py-8 mt-16"  
    >  
      <div className="container mx-auto px-4 text-center">  
        <div className="flex justify-center space-x-6 mb-6">  
          <a href="#" className="text-gray-300 hover:text-white transition-colors duration-300">  
            <Twitter size={24} className="text-white" />  
          </a>  
          <a href="#" className="text-gray-300 hover:text-white transition-colors duration-300">  
            <Bell size={24} className="text-white" /> {/* Discord placeholder */}  
          </a>  
          <a href="#" className="text-gray-300 hover:text-white transition-colors duration-300">  
            <Rocket size={24} className="text-white" /> {/* Telegram placeholder */}  
          </a>  
        </div>  
        <p className="text-sm text-gray-300">&copy; {new Date().getFullYear()} AVO. Todos los derechos reservados. | Construido con ❤️ AVO Protocol</p>  
      </div>  
    </motion.footer>  
  );  
};  

export default Footer;